import { IFileDataGeneric } from "@rf/schemas/file-data-generic.schema";
import mime, { Mime } from "mime";

// Tipo de datos para `FileData`
export type IFileData = IFileDataGeneric;

// Función para obtener el tipo MIME basado en la extensión
const getFileTypeFromExtension = (url: string): string | null => {
  const extension = url.split(".").pop()?.toLowerCase() as string;
  return mime.getType(extension);
};

interface IGenerateFileDataProps {
  file: File | string;
  name?: string;
  id?: string | number;
  comment?: string;
}
// Función para crear el objeto `FileData`
export const HGenerateFileData = ({
  file,
  name,
  id,
  comment
}: IGenerateFileDataProps): IFileData | null => {
  if (typeof file === "string" && file.startsWith("http")) {
    return {
      type: getFileTypeFromExtension(file)!,
      size: 0,
      file: null,
      url: file,
      error: false,
      deleted: false,
      isNewFile: false,
      progress: 100,
      name: name ?? "",
      order: 0,
      comment: comment ?? "",
      id: id ?? window.crypto.randomUUID()
    };
  } else if (file instanceof File) {
    const b = new Blob([file], { type: file.type });
    const url = URL.createObjectURL(b);
    return {
      type: file.type,
      size: file.size,
      file,
      url: url,
      error: false,
      deleted: false,
      isNewFile: true,
      progress: 0,
      name: file.name,
      id: window.crypto.randomUUID()
    } as IFileData;
  } else {
    return null;
  }
};
